import { keyframes } from '@emotion/react';
import { styled, SxProps } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';
import { Box } from '@mui/material';

export const mintRing1 = 'rgba(56, 142, 60, 0.20)'; // medium static ring
export const mintRing2 = 'rgba(56, 142, 60, 0.12)'; // largest static ring
export const pulseColor = 'rgba(56, 142, 60, 0.25)'; // color for the animated pulse

export const pulse = keyframes`
  0%   { transform: translate(-50%, -50%) scale(1);   opacity: 0.55; }
  80%  { transform: translate(-50%, -50%) scale(6.5); opacity: 0.1; }
  100% { transform: translate(-50%, -50%) scale(6.5); opacity: 0; }
`;

export const ChipRoot = styled(ButtonBase)(({ theme }) => ({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  padding: '8px 16px 8px 12px',
  height: 40,
  borderRadius: 9999,
  color: '#2d2d2d',
  boxShadow: '0 0 0 0 rgba(0,0,0,0)',
  overflow: 'hidden',
  WebkitTapHighlightColor: 'transparent',
}));

export const IconWrap = styled('span')(() => ({
  position: 'relative',
  borderRadius: '9999px',
  display: 'grid',
  placeItems: 'center',
  overflow: 'visible',
}));

export const PulseRing = styled('span')<{ delay?: number }>(({ delay = 0 }) => ({
  position: 'absolute',
  left: '50%',
  top: '50%',
  width: 32,
  height: 32,
  borderRadius: '50%',
  backgroundColor: pulseColor,
  transform: 'translate(-50%, -50%) scale(1)',
  animation: `${pulse} 2.0s ease-out ${delay}ms infinite`,
  pointerEvents: 'none',
}));

export const ActionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: theme.spacing(1),
  padding: `${theme.spacing(0)} ${theme.spacing(2)} ${theme.spacing(2)}`,
  paddingTop: '4px',
}));

export const commonIconButtonStyles: SxProps = {
  width: '48px',
  height: '48px',
  minWidth: 'unset',
  padding: 0,
  border: '1px solid #E0E1E4',
  borderRadius: '38px',
};

export const commonButtonStyles: SxProps = {
  padding: '7px 31px',
  justifyContent: 'center',
  alignItems: 'center',
  flex: '1 0 0',
  borderRadius: '38px',
  boxShadow: 'none',
  ':hover': {
    boxShadow: 'none',
  },
};
